/* eslint-disable @typescript-eslint/no-explicit-any */
import { type SbBlokData, storyblokEditable } from '@storyblok/react'
import { type FunctionComponent } from 'react'

// TODO:: "FIX any types"

export const withSbMapping = (
  WrappedComponent: FunctionComponent<any>,
  mapFn: (blok: any) => any
): React.FC<{ blok: SbBlokData }> => {
  const WithSbMappingComponent = ({ blok }: { blok: SbBlokData }): JSX.Element => {
    const mappedProps = mapFn(blok)
    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      <div {...storyblokEditable(blok)}>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <WrappedComponent {...mappedProps} />
      </div>
    )
  }

  WithSbMappingComponent.displayName = 'WithSbMapping'

  return WithSbMappingComponent
}
